/**
 * Contact popup (Gravity Form), opened on demand by any link whose href is
 * exactly "#open-popup" — unlike pop-up.js, this one never opens on load.
 */
export default class ContactPopup {
  static init() {
    const popup = document.querySelector('[data-module="contact-popup"]');

    if (!popup) {
      return;
    }

    const closeButton = popup.querySelector('.contact-popup__close');
    const dialog = popup.querySelector('.contact-popup__dialog');

    const openPopup = () => {
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      dialog?.focus();
    };

    const closePopup = () => {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    const onEscape = (event) => {
      if (event.key === 'Escape' && popup.classList.contains('is-open')) {
        closePopup();
      }
    };

    const onClickOutside = (event) => {
      if (event.target === popup || event.target === popup.querySelector('.contact-popup__overlay')) {
        closePopup();
      }
    };

    const onTriggerClick = (event) => {
      const trigger = event.target.closest('a[href="#open-popup"]');
      if (!trigger) {
        return;
      }
      event.preventDefault();
      openPopup();
    };

    document.addEventListener('click', onTriggerClick);
    closeButton?.addEventListener('click', closePopup);
    document.addEventListener('keydown', onEscape);
    popup.addEventListener('click', onClickOutside);
  }
}
